import * as types from '../../constants/log/transactionAttemptLogConstants';

export const transactionAttemptLogListRequest = ({
                                                     page,
                                                     pageLength,
                                                     beginDate,
                                                     endDate,
                                                     accountNo,
                                                     walletAddress,
                                                     status,
                                                     callback,
                                                     error,
                                                 }) => ({
    type: types.TRANSACTION_ATTEMPT_LOG_LIST_REQUEST,
    page,
    pageLength,
    beginDate,
    endDate,
    accountNo,
    walletAddress,
    status,
    callback,
    error,
})
